import { configurationAlreadyExistsKey } from 'app/area/experience-transfer/form/constants';
import { ExperienceTransferItemValidation } from 'app/area/experience-transfer/form/types-store';

export const clearValidationForKeys = (
  validation: ExperienceTransferItemValidation,
  keys: (keyof ExperienceTransferItemValidation)[]
): ExperienceTransferItemValidation => {

  if (!validation ||
    !Object.keys(validation).some(key => (validation?.[key]?.messages?.length ?? 0) > 0)) {
    return validation;
  }

  return Object.keys(validation).reduce((currentValidation, currentKey) =>
    keys.includes(currentKey as keyof ExperienceTransferItemValidation)
      ? currentValidation
      : {
        ...currentValidation,
        [currentKey]: validation[currentKey]
      }, {});
};

export const hasKeyViolationValidation = (validation: ExperienceTransferItemValidation) =>
  Object.keys(validation).some(key => key === configurationAlreadyExistsKey);
